(function (root) {
  'use strict';
  function fingerprint(cart) {
    return JSON.stringify(cart.items.map(i => [i.key, Number(i.variant_id || i.id), i.quantity]).sort((a,b) => a[0].localeCompare(b[0])));
  }
  function plan(cart, products, choice) {
    if (!['relief', 'standard'].includes(choice)) throw new Error('choose');
    const desired = new Map();
    const currentIds = new Set(cart.items.map(i => String(i.variant_id || i.id)));
    for (const item of cart.items) {
      const product = products[String(item.product_id)];
      if (!product) throw new Error('changed');
      const current = product.variants.find(v => v.id === Number(item.variant_id || item.id));
      if (!current) throw new Error('changed');
      let target = current;
      if (product.vatIndex >= 0) {
        const options = [...current.options];
        options[product.vatIndex] = choice === 'relief' ? 'VAT Relief' : 'Standard';
        target = product.variants.find(v => v.options.length === options.length && v.options.every((value,index) => value === options[index]));
        if (!target || (choice === 'relief' ? target.taxable : !target.taxable)) throw new Error('configuration');
      } else if (choice === 'standard' && !target.taxable && !item.gift_card) {
        throw new Error('configuration');
      }
      if (!target.available && target.id !== current.id) throw new Error('stock');
      if (target.id !== current.id && (Object.keys(item.properties || {}).length || item.selling_plan_allocation)) throw new Error('special');
      const key = String(target.id);
      desired.set(key, {id:target.id,quantity:(desired.get(key)?.quantity || 0) + item.quantity,price:target.price,taxable:target.taxable});
    }
    const updates = {}, retained = new Set();
    for (const item of cart.items) {
      const id = String(item.variant_id || item.id);
      if (desired.has(id) && !retained.has(id)) { updates[item.key] = desired.get(id).quantity; retained.add(id); }
      else updates[item.key] = 0;
    }
    for (const [id, value] of desired) if (!currentIds.has(id)) updates[id] = value.quantity;
    const changed = cart.items.some(item => updates[item.key] !== item.quantity) || [...desired.keys()].some(id => !currentIds.has(id));
    if (changed && cart.items.some(item => Object.keys(item.properties || {}).length || item.selling_plan_allocation)) throw new Error('special');
    return {updates, changed, desired:[...desired.values()]};
  }
  function matches(cart, desired) {
    const actual = new Map();
    for (const item of cart.items) { const id=Number(item.variant_id || item.id);actual.set(id,(actual.get(id)||0)+item.quantity); }
    return actual.size === desired.length && desired.every(v => actual.get(v.id) === v.quantity);
  }
  function validDeclaration(value, categories) {
    return Boolean(value && value.name?.trim() && categories.includes(value.category) && value.note?.trim() && value.confirmed === true);
  }
  const api = {fingerprint,plan,matches,validDeclaration};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.EezyVatCore = api;
})(typeof window !== 'undefined' ? window : globalThis);
